import { useSelector } from "react-redux";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { observabilityPipelineHttpClients } from "Reducers/observability/pipeline";

/**
 * Provides an Observability Pipeline HTTP Client for the current project environment.
 */
const useObservabilityPipelineHttpClient = () => {
  const environment = useSelectorWithUrlParams(environmentSelector);

  const clients = useSelector(observabilityPipelineHttpClients);

  const key = `${environment?.project}/${environment?.machine_name}`;
  if (key in clients === false) {
    return null;
  }

  return clients[key];
};

export default useObservabilityPipelineHttpClient;
